export default "__VITE_ASSET__S9hzbUp0__"